import {
  CreateRepresentativeCommandRequest,
  ReadRepresentativeAndStudentsQueryRequest,
  UpdateRepresentativeCommandRequest,
  UpdateRoleRepresentativeCommandRequest,
} from 'domain/entities/representative'
import { Query } from 'domain/models/query'
import {
  readInstitutionsByRepresentativeQuery,
  readRepresentativeAndStudentsQuery,
} from 'application/queries/representative'
import {
  createRepresentativeCommand,
  updateRepresentativeCommand,
  updateRoleRepresentativeCommand,
} from 'application/commands/representative'
import RepresentativeRepository from 'infraestructure/repositories/representativeRepository'

const representativeRepository = new RepresentativeRepository()

export class RepresentativeController {
  static async create(userData: CreateRepresentativeCommandRequest) {
    return await createRepresentativeCommand(representativeRepository, userData)
  }

  static async update(representativeId: string, userData: UpdateRepresentativeCommandRequest) {
    return await updateRepresentativeCommand(representativeRepository, representativeId, userData)
  }

  static async updateRole(
    promotionId: string,
    representativeId: string,
    data: UpdateRoleRepresentativeCommandRequest,
  ) {
    return await updateRoleRepresentativeCommand(
      representativeRepository,
      promotionId,
      representativeId,
      data,
    )
  }

  static async getInstitutionsByRepresentative(query?: Query) {
    return await readInstitutionsByRepresentativeQuery(representativeRepository, query)
  }

  static async getRepresentativeAndStudentsById(params: ReadRepresentativeAndStudentsQueryRequest) {
    return await readRepresentativeAndStudentsQuery(representativeRepository, params)
  }
}
